class ProductReviews extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setStars()
  }

  async setStars () {
    const productId = this.dataset.id

    try {
      const response = await fetch(
        `https://api-cdn.yotpo.com/v1/widget/${window.yotpoStrings.apiKey}/products/${productId}/reviews.json`,
      )

      if (response.ok) {
        const reviews = await response.json()

        const totalReviews = reviews.response.bottomline.total_review
        const averageScore = reviews.response.bottomline.average_score
        const roundedScore = averageScore.toFixed(2)

        if (this.els?.reviews?.element) {
          this.els.reviews.element.innerHTML = `${totalReviews}`
        }

        if (this.els?.rating?.element) {
          this.els.rating.element.innerHTML = `${roundedScore}`
        }
      }
    } catch (error) {
      console.error('Fetch error:', error)
    }
  }
}

if (!customElements.get('product-reviews')) {
  customElements.define('product-reviews', ProductReviews)
}
